import React from 'react';
import { Tag } from 'src/@vymo/ui/atoms';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import {
  REVYRE_DETAILS,
  REVYRE_DETAILS_360,
  REVYRE_WORKFLOW_DETAILS,
  REVYRE_WORKFLOW_DETAILS_360,
} from 'src/modules/constants';
import { renderModule } from 'src/workspace/slice';
import { REVYRE } from '../../constant';

export const getTableData = (props, relatedRecords, module, revyreConfig) => {
  if (props.revyre) {
    const tableData: Array<{
      list: any;
      columns: any;
      name: string;
      code: string;
    }> = [];

    const list = (relatedRecords?.list || []).map((item) => item.mutatedEntity);
    const columns = (revyreConfig[module.code]?.defaultFields || [])
      .filter(({ visible }) => (visible?.enabledFor || []).includes('web'))
      .map((column) =>
        column.code === 'stateId'
          ? {
              ...column,
              cell: (value: string) => {
                const states = revyreConfig?.[module.code]?.states || [];

                const correspondingState = states.find(
                  (event) => event?.id === value,
                );

                return <Tag label={correspondingState?.name} />;
              },
            }
          : column,
      );

    tableData.push({
      name: module.name,
      code: module.code,
      list,
      columns,
    });

    return tableData;
  }
  return [];
};

export const handleRelatedRecordNavigation = (
  rowId: string,
  props,
  dispatch,
) => {
  const { revyre, module: selectedModule } = props;
  const newDetailsPage = getGrowthBookFeatureFlag('enable-details-360');
  const revyreWorkflowDetailsModuleId = newDetailsPage
    ? REVYRE_WORKFLOW_DETAILS_360
    : REVYRE_WORKFLOW_DETAILS;
  if (revyre) {
    if (REVYRE.COLLECT_IQ.WORKFLOW_TYPES.includes(selectedModule?.code)) {
      const { workflowType } = selectedModule;
      dispatch(
        renderModule({
          id: revyreWorkflowDetailsModuleId,
          props: {
            domainType: 'workflow',
            workflowType,
            entityId: rowId,
          },
        }),
      );
    } else {
      const { workflowType: domainType } = selectedModule;
      dispatch(
        renderModule({
          id: newDetailsPage ? REVYRE_DETAILS_360 : REVYRE_DETAILS,
          props: {
            domainType,
            entityId: rowId,
          },
        }),
      );
    }
  }
  // redirection on legacy web is fixed in PE-45679-legacy branch
};
